var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpoScreensaver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-1b095031-aa2d-4d58-b29d-b732f25cb8c0",
    "data-name": "art",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-ac377de6-9a1d-42c4-841c-2e4ac0b88323",
    x1: 22.5,
    y1: 52.5,
    x2: 82.5,
    y2: 52.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m68.33,66.67c-3.79,0-7.34-1.47-10.02-4.15l-15.85-15.8c-1.55-1.55-3.6-2.4-5.78-2.4s-4.23.85-5.78,2.39c-1.54,1.54-2.39,3.6-2.39,5.78s.85,4.23,2.39,5.78c1.54,1.54,3.6,2.39,5.78,2.39s4.24-.85,5.78-2.39c1.17-1.17,3.07-1.17,4.24,0,1.17,1.17,1.17,3.07,0,4.24-2.68,2.68-6.24,4.15-10.02,4.15s-7.34-1.47-10.02-4.15c-2.68-2.68-4.15-6.24-4.15-10.02s1.47-7.34,4.15-10.02,6.24-4.15,10.02-4.15,7.34,1.47,10.02,4.15l15.85,15.8c1.55,1.55,3.6,2.4,5.78,2.4s4.23-.85,5.78-2.39c1.54-1.54,2.39-3.6,2.39-5.78s-.85-4.23-2.39-5.78c-1.54-1.54-3.6-2.39-5.78-2.39s-4.24.85-5.78,2.39c-1.17,1.17-3.07,1.17-4.24,0-1.17-1.17-1.17-3.07,0-4.24,2.68-2.68,6.24-4.15,10.02-4.15s7.34,1.47,10.02,4.15c2.68,2.68,4.15,6.24,4.15,10.02s-1.47,7.34-4.15,10.02-6.24,4.15-10.02,4.15Z",
    fill: "url(#uuid-ac377de6-9a1d-42c4-841c-2e4ac0b88323)",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpoScreensaver);
export default __webpack_public_path__ + "static/media/expo_screensaver.91770c1eccc33e25ac64ff7e812fe2c6.svg";
export { ForwardRef as ReactComponent };